import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function ChangePassword() {
  const { user, changePassword, logout } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 10) return toast.error("New password must be at least 10 characters");
    if (next !== confirm) return toast.error("Passwords do not match");
    setLoading(true);
    try {
      await changePassword(current, next);
      toast.success("Password updated — welcome!");
    } catch (err) {
      toast.error(apiError(err, "Could not change password"));
    } finally {
      setLoading(false);
    }
  };

  const inp = "h-12 w-full rounded-xl border border-white/10 bg-black px-4 text-white outline-none transition-colors focus:border-[#2997ff]";

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-black px-6">
      <div className="pointer-events-none absolute left-1/2 top-24 h-72 w-72 -translate-x-1/2 rounded-full bg-[#2997ff] opacity-20 blur-[120px]" />
      <div className="mf-fade-in relative w-full max-w-sm">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-[#2997ff]/15 text-[#2997ff]">
            <ShieldCheck size={22} />
          </div>
          <h1 className="text-2xl font-extrabold tracking-tight">Set your password</h1>
          <p className="mt-1 text-sm text-[#98989d]">Welcome {user?.name}. Please choose a new password to continue.</p>
        </div>
        <form onSubmit={submit} className="space-y-3 rounded-3xl border border-white/10 bg-[#121214] p-6">
          <input data-testid="cp-current" type="password" className={inp} placeholder="Temporary password" value={current} onChange={(e) => setCurrent(e.target.value)} required />
          <input data-testid="cp-new" type="password" className={inp} placeholder="New password (min 10 chars)" value={next} onChange={(e) => setNext(e.target.value)} required />
          <input data-testid="cp-confirm" type="password" className={inp} placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
          <button data-testid="cp-submit" type="submit" disabled={loading} className="flex h-12 w-full items-center justify-center rounded-xl bg-[#2997ff] font-semibold text-white transition-transform active:scale-[0.98] disabled:opacity-60">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Save & continue"}
          </button>
          <button type="button" onClick={logout} className="w-full text-center text-sm text-[#98989d]">Sign out</button>
        </form>
      </div>
    </div>
  );
}
